import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteCity() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((cityId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/city-catalog/${cityId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
